import Button from 'components/shared/Button/Button';

import StatesCellSelect from '../components/StatesCellSelect';

const baseColumns = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    valueGetter: (params) => {
      const provider = params.data;
      return provider?.type === 'billing'
        ? provider?.bill_name
        : provider?.fullName || provider?.label;
    }
  },
  {
    field: 'npi',
    headerName: 'NPI',
    maxWidth: 120,
    flex: 1,
    valueGetter: (params) => {
      const provider = params.data;
      return provider?.type === 'billing' ? provider?.bill_npi : provider?.billingInfo?.npi || '-';
    }
  },
  {
    field: 'type',
    headerName: 'Type',
    flex: 1,
    maxWidth: 160,
    valueGetter: (params) => {
      const provider = params.data;
      return provider?.type === 'billing' ? 'Billing provider' : 'Rendering provider';
    }
  }
];

export const getProviderColumns = ({
  showStates,
  enableSelection,
  onRemove,
  stateOptions,
  oppositeStateMap,
  onStatesChange,
  isInNetwork
}) => {
  const statesColumn = showStates && {
    field: 'state_ids',
    headerName: 'States',
    flex: 2,
    minWidth: 200,
    sortable: false,
    filter: false,
    autoHeight: true,
    cellStyle: { display: 'flex', alignItems: 'center', paddingTop: 4, paddingBottom: 4 },
    cellRenderer: (params) => (
      <StatesCellSelect
        data={params.data}
        stateOptions={stateOptions}
        oppositeStateMap={oppositeStateMap}
        onStatesChange={onStatesChange}
        isInNetwork={isInNetwork}
      />
    )
  };

  if (onRemove && !enableSelection) {
    return [
      {
        maxWidth: 50,
        flex: 0,
        cellRenderer: (params) => (
          <Button
            variant="link"
            color="neutral"
            icon="close-mono"
            onClick={() => onRemove(params.data?.value ?? params.data?.id)}
          />
        ),
        sortable: false,
        filter: false,
        resizable: false
      },
      ...baseColumns,
      ...(statesColumn ? [statesColumn] : [])
    ];
  }

  if (enableSelection) {
    return [
      {
        ...baseColumns[0],
        checkboxSelection: true,
        headerCheckboxSelection: true
      },
      ...baseColumns.slice(1)
    ];
  }

  return [...baseColumns, ...(statesColumn ? [statesColumn] : [])];
};
